import { useApiQuery } from "../../core/api/useApiQuery"
import { selectUserId } from "../../modules/login/loginSelectors"
import { useAppSelector } from "../../modules/store/storeHooks"
import { getUserDetails, UserQuery } from "../../modules/users/userApi"
import { ModuleName } from "../../modules/users/userTypes"

const useActiveModules = () => {
    const userId = useAppSelector(selectUserId)

    const { data: userDetails, isFetching } = useApiQuery(getUserDetails, {
        queryName: UserQuery.USER_DETAILS,
        dependencies: {
            userId: userId ?? 0,
        },
        enabled: Boolean(userId),
    })

    const activeModules = new Set(userDetails?.user?.modules?.filter((m) => m.isActive)?.map((m) => m.name))
    const hasModule = (name: ModuleName) => activeModules.has(name)

    return {
        isFetching,
        activeModules,
        //
        hasRefillWallet: hasModule(ModuleName.REFILL_WALLET),
        hasCatering: hasModule(ModuleName.CATERING),
        hasBooking: hasModule(ModuleName.BOOKING),
        hasTakeAway: hasModule(ModuleName.TAKE_AWAY),
        hasAppPayment: hasModule(ModuleName.APP_PAYMENT),
        hasPosPayment: hasModule(ModuleName.POS_PAYMENT),
    }
}

export { useActiveModules }
